import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppRouter from "./app-router";
import { ThemeProvider } from "./context/useThemeContext";
import { LoadingProvider } from "./context/useLoadingContext";
import { Toaster } from "react-hot-toast";
import Providers from "./providers";

// Discount cache is managed within utils/discounts when used

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <Providers>
      <ThemeProvider>
        <LoadingProvider>
          <Toaster position="top-center" reverseOrder={false} />
          <AppRouter />
        </LoadingProvider>
      </ThemeProvider>
    </Providers>
  </React.StrictMode>
);

// Discount cache cleanup is handled lazily by utils/discounts users

// Register service worker for PWA functionality
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration: ServiceWorkerRegistration) => {})
      .catch((registrationError: Error) => {});
  });
}
